import { getPath } from '@/router/common'

const baseUrl = {
  title: '导入模板',
  path: 'NewInventoryManagement'
}
export default [
  {
    path: getPath('AreaSearch', baseUrl),
    name: 'AreaSearch',
    component: () => import(/* webpackChunkName: "AreaSearch" */ '@/views/newInventoryManagement/areaSearch/index.vue'),
    meta: {
      title: '库区管理'
    }
  },
  {
    path: getPath('LocationSearch', baseUrl),
    name: 'LocationSearch',
    component: () => import(/* webpackChunkName: "LocationSearch" */ '@/views/newInventoryManagement/locationSearch/index.vue'),
    meta: {
      title: '库位主档'
    }
  },
  {
    path: getPath('AccountCalc', baseUrl),
    name: 'AccountCalc',
    component: () => import(/* webpackChunkName: "AccountCalc" */ '@/views/newInventoryManagement/accountCalc/index.vue'),
    meta: {
      title: '结存处理'
    }
  },
  {
    path: getPath('AccountBalance', baseUrl),
    name: 'AccountBalance',
    component: () => import(/* webpackChunkName: "AccountBalance" */ '@/views/newInventoryManagement/accountBalance/index.vue'),
    meta: {
      title: '结存单明细表'
    }
  },
  {
    path: getPath('NewInboundMgn', baseUrl),
    name: 'NewInboundMgn',
    component: () => import('@/views/newInventoryManagement/newInboundMgn/index.vue'),
    meta: {
      title: '新-入库单管理'
    }
  },
  {
    path: getPath('NewInStoreImportCommodity', baseUrl),
    name: 'NewInStoreImportCommodity',
    component: () => import(/* webpackChunkName: "NewInStoreImportCommodity" */ '@/views/newInventoryManagement/newInStoreImportCommodity/index.vue'),
    meta: {
      title: '入库导入记录'
    }
  },
  {
    path: getPath('NewInStoreUPIndex', baseUrl),
    name: 'NewInStoreUPIndex',
    component: () => import(/* webpackChunkName: "NewInStoreUPIndex" */ '@/views/newInventoryManagement/newInStoreUPIndex/index.vue'),
    meta: {
      title: '入库导入明细'
    }
  },
  {
    path: getPath('NewAddOrEditInbound', baseUrl),
    name: 'NewAddOrEditInbound',
    component: () => import(/* webpackChunkName: "NewAddOrEditInbound" */ '@/views/newInventoryManagement/newAddOrEditInbound/index.vue'),
    meta: {
      title: '新增修改入库单'
    }
  },
  {
    path: getPath('SetPlatform', baseUrl),
    name: 'SetPlatform',
    component: () => import(/* webpackChunkName: "SetPlatform" */ '@/views/newInventoryManagement/setPlatform/index.vue'),
    meta: {
      title: '新增修改月台'
    }
  },
  {
    path: getPath('TaskOverAddOrEdit', baseUrl),
    name: 'TaskOverAddOrEdit',
    component: () => import(/* webpackChunkName: "SetPlatform" */ '@/views/newInventoryManagement/taskOverAddOrEdit/index.vue'),
    meta: {
      title: '新增修改收货'
    }
  },
  {
    path: getPath('OpenCkdSelectDailog', baseUrl),
    name: 'OpenCkdSelectDailog',
    component: () => import(/* webpackChunkName: "OpenCkdSelectDailog" */ '@/views/newInventoryManagement/openCkdSelectDailog/index.vue'),
    meta: {
      title: '入库单列表'
    }
  },
  {
    path: getPath('NewOutboundMgn', baseUrl),
    name: 'NewOutboundMgn',
    component: () => import(/* webpackChunkName: "NewOutboundMgn" */ '@/views/newInventoryManagement/newOutboundMgn/index.vue'),
    meta: {
      title: '新-出库单管理'
    }
  },
  {
    path: getPath('NewOutStoreImportCommodity', baseUrl),
    name: 'NewOutStoreImportCommodity',
    component: () => import(/* webpackChunkName: "NewOutStoreImportCommodity" */ '@/views/newInventoryManagement/newOutStoreImportCommodity/index.vue'),
    meta: {
      title: '出库导入记录'
    }
  },
  {
    path: getPath('NewOutStoreUPIndex', baseUrl),
    name: 'NewOutStoreUPIndex',
    component: () => import(/* webpackChunkName: "NewOutStoreUPIndex" */ '@/views/newInventoryManagement/newOutStoreUPIndex/index.vue'),
    meta: {
      title: '出库导入'
    }
  },
  {
    path: getPath('NewCreateTYD_part', baseUrl),
    name: 'NewCreateTYD_part',
    component: () => import('@/views/newInventoryManagement/newCreateTYD_part/index.vue'),
    meta: {
      title: '拆票生成托运单'
    }
  },
  {
    path: getPath('NewAddOrEditOutbound', baseUrl),
    name: 'NewAddOrEditOutbound',
    component: () => import(/* webpackChunkName: "NewAddOrEditOutbound" */ '@/views/newInventoryManagement/newAddOrEditOutbound/index.vue'),
    meta: {
      title: '新增修改出库单'
    }
  },
  {
    path: getPath('AddOrEditDelivery', baseUrl),
    name: 'NewInventoryManagement_AddOrEditDelivery',
    component: () => import(/* webpackChunkName: "NewInventoryManagement_AddOrEditDelivery" */ '@/views/newInventoryManagement/addOrEditDelivery/index.vue'),
    meta: {
      title: '分拣'
    }
  },
  {
    path: getPath('AddDeliverGoods', baseUrl),
    name: 'NewInventoryManagement_AddDeliverGoods',
    component: () => import(/* webpackChunkName: "NewInventoryManagement_AddDeliverGoods" */ '@/views/newInventoryManagement/addDeliverGoods/index.vue'),
    meta: {
      title: '配送'
    }
  },
  {
    path: getPath('RealtimeSkuStockSearch', baseUrl),
    name: 'RealtimeSkuStockSearch',
    component: () => import(/* webpackChunkName: "RealtimeSkuStockSearch" */ '@/views/newInventoryManagement/realtimeSkuStockSearch/index.vue'),
    meta: {
      title: '新-实时库存'
    }
  },
  {
    path: getPath('ShoveSkuStockSearch', baseUrl),
    name: 'ShoveSkuStockSearch',
    component: () => import(/* webpackChunkName: "ShoveSkuStockSearch" */ '@/views/newInventoryManagement/shoveSkuStockSearch/index.vue'),
    meta: {
      title: '新-库存推移'
    }
  },
  {
    path: getPath('NewSortingOrder', baseUrl),
    name: 'NewSortingOrder',
    component: () => import(/* webpackChunkName: "NewSortingOrder" */ '@/views/newInventoryManagement/newSortingOrder/index.vue'),
    meta: {
      title: '新-出库分拣'
    }
  },
  {
    path: getPath('NewDeliverGoods', baseUrl),
    name: 'NewDeliverGoods',
    component: () => import(/* webpackChunkName: "NewDeliverGoods" */ '@/views/newInventoryManagement/newDeliverGoods/index.vue'),
    meta: {
      title: '新-出库配送'
    }
  },
  {
    path: getPath('NewInternalBusiness', baseUrl),
    name: 'NewInternalBusiness',
    component: () => import(/* webpackChunkName: "NewInternalBusiness" */ '@/views/newInventoryManagement/newInternalBusiness/index.vue'),
    meta: {
      title: '新-调拨单'
    }
  },
  {
    path: getPath('NewInventoryChecking', baseUrl),
    name: 'NewInventoryChecking',
    component: () => import(/* webpackChunkName: "NewInventoryChecking" */ '@/views/newInventoryManagement/newInventoryChecking/index.vue'),
    meta: {
      title: '新-盘点单'
    }
  },
  {
    path: getPath('NewAddOrEditInventoryChecking', baseUrl),
    name: 'NewAddOrEditInventoryChecking',
    component: () => import(/* webpackChunkName: "NewAddOrEditInventoryChecking" */ '@/views/newInventoryManagement/newAddOrEditInventoryChecking/index.vue'),
    meta: {
      title: '新增修改盘点单'
    }
  },
  {
    path: getPath('NewInventoryProfit', baseUrl),
    name: 'NewInventoryProfit',
    component: () => import(/* webpackChunkName: "NewInventoryProfit" */ '@/views/newInventoryManagement/newInventoryProfit/index.vue'),
    meta: {
      title: '新-盘盈单'
    }
  },
  {
    path: getPath('NewAddOrEditInventoryProfit', baseUrl),
    name: 'NewAddOrEditInventoryProfit',
    component: () => import(/* webpackChunkName: "NewAddOrEditInventoryProfit" */ '@/views/newInventoryManagement/newAddOrEditInventoryProfit/index.vue'),
    meta: {
      title: '盘盈单明细详情'
    }
  },
  {
    path: getPath('NewInventoryLoss', baseUrl),
    name: 'NewInventoryLoss',
    component: () => import(/* webpackChunkName: "NewInventoryLoss" */ '@/views/newInventoryManagement/newInventoryLoss/index.vue'),
    meta: {
      title: '新-盘亏单'
    }
  },
  {
    path: getPath('NewAddOrEditInventoryLoss', baseUrl),
    name: 'NewAddOrEditInventoryLoss',
    component: () => import(/* webpackChunkName: "NewAddOrEditInventoryLoss" */ '@/views/newInventoryManagement/newAddOrEditInventoryLoss/index.vue'),
    meta: {
      title: '盘亏单明细'
    }
  },
  {
    path: getPath('NewAddOrEditInternalBusiness', baseUrl),
    name: 'newInventoryManagement_newAddOrEditInternalBusiness',
    component: () => import(/* webpackChunkName: "newInventoryManagement_newAddOrEditInternalBusiness" */ '@/views/newInventoryManagement/newAddOrEditInternalBusiness/index.vue'),
    meta: {
      title: '新增修改查看调拨单'
    }
  }
]
